import { IComponentOptions } from 'angular';
import { GradPlanningTransferStepperCtrl } from './grad-planning-transfer-stepper.controller';

export const GradPlanningTransferStepperComponent: IComponentOptions = {
  bindings: {
    //
  },
  controller: GradPlanningTransferStepperCtrl,
  template: require('./grad-planning-transfer-stepper.html'),
};
